<template>
  <div
    id="modal"
    @click.self="clickOutside"
    :class="[isScaledUpParent ? 'scaled-up-container' : '', { 'blurred-bg': component.bind.hasBlurBackground }]"
  >
    <div
      v-if="isMounted"
      class="modal-container"
      ref="innerModal"
      :style="{...modalStyle, backgroundColor: getBackgroundColor}"
    >
      <div tabindex="0" v-if="showExitIcon" id="close-icon" ref="closeIcon" class="close-icon-wrapper"
       @keypress.enter="closeModal" @click="closeModal" :aria-label="$t('app.classes.modal.closeIcon.ariaLabel.text')"
        :lang="narratorLang">
       <div class="close-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path
              id="Path_8625"
              class="cls-1"
              data-name="Path 8625"
              d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,
              19,12,13.41,17.59,19,19,17.59,13.41,12Z"
              transform="translate(-5 -5)"
              fill="var(--midGrey2)"
            />
          </svg>
       </div>
      </div>
      <component
        class="modal-component"
        :class="{scaledUp: isScaledUp}"
        :salesPopupType="component.salesPopupType"
        v-bind:is="component.bind.is"
        v-bind="component.bind"
        v-on="component.on"
      >
        <template slot="modal-header" slot-scope="{ titleText, titleStyle, hasSeparator }">
          <modal-header
            :titleText="titleText"
            :titleStyle="titleStyle"
            :hasSeparator="hasSeparator"
          />
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import ModalHeader from '@/components/shared/elements/modal/ModalHeader';
import { mapGetters } from 'vuex';

export default {
  name: 'ModalComponent',
  components: {
    'modal-header': ModalHeader
  },
  props: {
    component: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      required: false,
      default: '50%'
    },
    height: {
      type: String,
      required: false
    },
    overflow: {
      type: String,
      required: false
    },
    hasExit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      narratorLang: 'settings/getNarratorLanguage'
    }),
    getBackgroundColor() {
      return this.component.backgroundColor || 'white';
    },
    isScaledUp() {
      return this.component.isScaledUp;
    },
    isScaledUpParent() {
      return (
        this.component.isScaledUp &&
        (navigator.userAgent.includes('Mozilla') ||
          navigator.userAgent.includes('Firefox'))
      );
    },
    showExitIcon() {
      if (this.component.bind.hasExit !== undefined) {
        return this.component.bind.hasExit;
      }
      return this.hasExit;
    }
  },
  data() {
    return {
      modalStyle: {
        width: this.component.width,
        height: this.component.height || 'unset',
        maxHeight: this.component.maxHeight || 'none',
        overflow: this.component.overflow || 'visible'
      },
      upperPicture: null,
      isMounted: false
    };
  },
  methods: {
    clickOutside() {
      if (this.component.bind.closeable) {
        this.closeModal();
      }
    },
    closeModal() {
      this.$eventBus.closeModal();
      document.querySelector('#app').classList.remove('blurred');
    },
    disableScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableScroll() {
      document.body.style.overflow = null;
    },
    switchAndFocus() {
      if (this.showExitIcon) {
        setTimeout(() => {
          this.$refs.closeIcon.focus();
        }, 50);
      }
    }
  },
  mounted() {
    this.isMounted = true;
    this.upperPicture = this.component.upperPicture;
    if (this.component.bind.hasBlurBackground) {
      document.querySelector('#app').classList.add('blurred');
    }
    this.disableScroll();
    if (this.component.bind.is.name !== 'CreateNewClassModal') {
      this.switchAndFocus();
    }
    document.querySelector('#app').classList.add('disable-scroll');
  },
  beforeDestroy() {
    this.enableScroll();
    document.querySelector('#app').classList.remove('blurred');
    document.querySelector('#app').classList.remove('disable-scroll');
  }
};
</script>

<style lang="scss" scoped>
#modal {
  background-color: rgba(var(--terraGreyRGB), 0.9);
  position: fixed;
  z-index: z('modal');
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  // overflow: hidden;

  &.blurred-bg {
    background-color: rgba(97, 97, 97, 0.48);
  }

  .modal-container {
    max-width: 100vw;
    max-height: 100vh;
    transition: all 0.4s ease-in-out;
    z-index: 20;
    overflow: hidden;
    box-shadow: $nexus-box-shadow;

    @include center(both);
    border-radius: 8px;

    .scaledUp {
      @media (min-width: 1500px) {
        $zoomRate: 1.25;
        zoom: $zoomRate;
      }
    }
  }
  .scaled-up-container {
    @media (min-width: 1500px) {
      -moz-transform: scale(1.25);
    }
  }
  .close-icon-wrapper {
    position: absolute;
    top: 11px;
    right: 11px;
    height: 24px;
    width: 24px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .close-icon {
      cursor: var(--pointer);
      width: 14px;
      height: 14px;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/ .cls-2 {
        fill: transparent;
      }
      /deep/ .cls-1 {
        fill: var(--midGrey2);
        transition: $base-transition;
      }
      &:hover /deep/ .cls-1 {
        fill: var(--terraGrey);
      }
    }
  }
}
// @media screen and (max-height: 700px) {
//   .modal-container {
//     max-height: 90vh !important;
//   }
//   .modal-component {
//     max-height: 90vh !important;
//     overflow-y: scroll;
//   }
// }
@media screen and (max-width: breakpoint('s-screen')) {
  .modal-component {
    max-width: 95vw;
    max-height: 95vh;
  }
  /deep/.modal-new-assignment-modal {
    #modal-header {
      height: fit-content;
      min-height: 76px; // iOS 12.3.1 (5S) transparent header bugs
      border-radius: 8px;
      background: #fff;
    }
  }
}
@media screen and(max-height: 700px) {
  .create-new-class-modal {
    max-height: 75vh;
    height: auto;
    // overflow-y: visible !important;
  }
  #language-select-modal {
    overflow-y: visible !important;
  }
  .modal-component {
    display: flex !important;
    flex-direction: column;
    max-height: 75vh !important;
    // overflow-y: auto;
  }
  .modal-component::-webkit-scrollbar {
    display: none
  }
  .module-vocabulary-modal {
    overflow: hidden;
  }
  .move-student-modal {
    overflow-y: visible !important;
  }
  /deep/.modal-new-assignment-modal {
    #modal-header {
      height: fit-content;
      min-height: 76px; // iOS 12.3.1 (5S) transparent header bugs
      border-radius: 8px;
      background: #fff;
    }
  }

}

@media screen and(max-height: 450px) {
  .create-new-class-modal {
    overflow-y: auto !important;
  }
  #language-select-modal {
    overflow-y: auto !important;
  }
  .move-student-modal {
    overflow-y: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/elements/modal/Modal.vue